import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IoCompassOutline, IoArrowBack } from 'react-icons/io5';
//
import Botao from '../../components/Botao';
//
import styles from './not-found.module.css';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={styles['container']}>
      <div className={styles['card']}>
        <div className={styles['icon-wrapper']}>
          <IoCompassOutline className={styles['icon']} />
        </div>

        <span className={styles['code']}>404</span>
        <h1 className={styles['title']}>Página não encontrada</h1>
        <p className={styles['message']}>
          O endereço que você acessou não existe ou foi movido. Verifique o link recebido e tente
          novamente.
        </p>

        <Botao
          icon={<IoArrowBack />}
          text="Voltar ao início"
          onClick={() => navigate('/')}
          color="primary"
          style={{ marginTop: '1rem' }}
        />
      </div>
    </div>
  );
}
